import { atom } from 'jotai';

export const braintreeClientTokenAtom = atom('');
